import React from "react";
import GrComponentFactory from "../../gr_component_factory";
import GrPropTypes from "../../shared/gr_prop_types";
import BookCoverRow from "../shared/book_cover_row";

export default GrComponentFactory.createClass({
  displayName: "ReadingChallengeCompleteDetails",
  propTypes: {
    user: GrPropTypes.user().isRequired,
    goalNum: React.PropTypes.number.isRequired,
    url: React.PropTypes.string.isRequired,
    numRead: React.PropTypes.number.isRequired,
    challenge: React.PropTypes.shape({
      title: React.PropTypes.string.isRequired,
    }),
    books: React.PropTypes.arrayOf(GrPropTypes.book()).isRequired,
    urcDeprecateViewChallengeLink: React.PropTypes.bool,
  },

  renderBookNumText() {
    return `${this.props.goalNum} ${this.props.goalNum === 1 ? "book" : "books"}`;
  },

  render() {
    return <div className="gr-newsfeedItem__details">
             Congratulate {this.props.user.viewableName}!
             <div className="readingChallengeNewsfeedItem__challengeDescription">
               {this.props.user.viewableName} has completed the goal of reading {""}
               {this.renderBookNumText()} for the {this.props.challenge.title}!
               <BookCoverRow numBooksRead={this.props.numRead}
                             url={this.props.url}
                             books={this.props.books} />
               {!this.props.urcDeprecateViewChallengeLink && (
                 <a href={this.props.url} id="viewChallengeLink" className="u-displayBlock">
                   View Challenge
                 </a>
               )}
             </div>
           </div>;
  },
});
